import { render, staticRenderFns } from "./FoodcourtFeedbackList.vue?vue&type=template&id=16638334&scoped=true"
import script from "./FoodcourtFeedbackList.vue?vue&type=script&lang=js"
export * from "./FoodcourtFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtFeedbackList.vue?vue&type=style&index=0&id=16638334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16638334",
  null
  
)

export default component.exports